






























import {
  defineComponent,
  PropType,
  ref,
  watch
} from '@nuxtjs/composition-api';
import {
  getName as getProductName
} from '@wemade-vsf/catalog/lib/runtime/product/getters/productGetters';
import { useCustomerPricing } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomerPricing';
import type { BundleItem, BundleItemOption } from '@wemade-vsf/magento-api';
import type { SelectedBundleProductOptions } from '@wemade-vsf/catalog/lib/runtime/product/helpers/bundleProduct';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { SfCheckbox, SfPrice } from '@storefront-ui/vue';

export default defineComponent({
  name: 'BundleCheckboxRenderer',
  components: {
    SfCheckbox,
    SfPrice
  },
  props: {
    bundle: {
      type: Object as PropType<BundleItem>,
      required: true
    },
    selectedOptions: {
      type: Object as PropType<SelectedBundleProductOptions>,
      required: true
    }
  },
  emits: ['update:selectedOptions'],
  setup (props, { emit }) {
    const { getPriceForProduct } = useCustomerPricing();

    const selected = ref<string[]>([]);

    function emitChange(option: BundleItemOption) {
      if (selected.value.includes(option.uid)) {
        if (Array.isArray(props.selectedOptions[(props.bundle as BundleItem).uid!])) {
          const newOptions = (props.selectedOptions[(props.bundle as BundleItem).uid!] as any[]).filter((opt) => opt.uid !== option.uid)
          emit('update:selectedOptions', newOptions);
        } else {
          emit('update:selectedOptions', []);
        }
      } else {
        const newOptions = [
            ...(props.selectedOptions[(props.bundle as BundleItem).uid!] as any[]) ?? [],
            {
              uid: option.uid,
              quantity: 1,
              price: getPriceForProduct(option.product! as unknown as Product).final
            }
          ];
        emit('update:selectedOptions', newOptions);
      }
    }

    watch (() => props.selectedOptions, (value) => {
      selected.value = (value[(props.bundle as BundleItem).uid!] as any[])?.map((opt: any) => opt.uid) || [];
    }, { immediate: true });

    return {
      selected,
      emitChange,
      getProductName,
      getProductPrice: getPriceForProduct
    }
  }
})
